
                    import wasm from "../../dist/pkg/esm/perspective.cpp.wasm";
                    export default Promise.resolve(wasm);
                